var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.1 14.6a4.882 4.882 0 00-1.9.383l-1.936-3.22V8.91h-.001l-.001-.003h.002V8.3a.7.7 0 00-.7-.7h-2.8a.7.7 0 000 1.4h2.156v2.18l-7.724 1.247-1.133-2.265 1.672-.144A.51.51 0 0012.69 9H8.295a.7.7 0 000 1.4l1.267-.109.573 1.145-1.715 3.429A4.85 4.85 0 006.9 14.6a4.9 4.9 0 104.83 5.601h1.6a2.084 2.084 0 004.044-.965l3.716-5.047.923 1.535A4.874 4.874 0 1025.1 14.6zM6.9 23a3.5 3.5 0 010-7 3.464 3.464 0 01.889.129l-1.53 3.06a.7.7 0 00.626 1.013h3.444A3.506 3.506 0 016.9 23zm1.117-4.199l1.025-2.049a3.49 3.49 0 011.287 2.05zm5.311 0H11.73a4.883 4.883 0 00-2.048-3.33l1.236-2.47 2.654 5.309a2.089 2.089 0 00-.244.491zM15.3 20.2a.7.7 0 11.7-.7.7.7 0 01-.7.7zm1.329-2.314a2.008 2.008 0 00-1.902-.397l-1.875-3.75 7.262-1.172.194.323zM25.1 23a3.488 3.488 0 01-2.36-6.067l1.76 2.928a.7.7 0 101.2-.722l-1.76-2.926A3.46 3.46 0 0125.1 16a3.5 3.5 0 010 7z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--bike-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'BikeIcon';
export default Icon;